// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1190":"019270c2","6287":"4e3e041b","8842":"639088ed"}[chunkId] + ".chunk.css";
};